export default __webpack_public_path__ + "static/media/victor_lin.d3b8a93e.jpg";